import React, { useCallback } from 'react';
import {
  AppContent,
  StandardNoAccessErrorMessage,
  Tabs,
} from '@common/components';
import { useSetBreadcrumbs } from 'works/legacy/lib/client-store';
import { useNavigate, useParams } from '@common/hooks';
import {
  BillingDisputeList,
  BillingInvoiceList,
  BillingPageStats,
} from '@pay-bill/components';
import { useCurrentMembership } from '@identity/hooks';

export const BillingPage = () => {
  useSetBreadcrumbs([{ name: 'Billing', path: '/works/billing' }]);

  const currentMembership = useCurrentMembership();
  const canShowDisputes = currentMembership.canShowDisputes;
  const canShowInvoices = currentMembership.canShowInvoices;

  const navigate = useNavigate();
  const params = useParams<{ tab?: 'invoices' | 'disputes' }>();

  const handleTabChange = useCallback(
    (key: string) => {
      navigate(`/works/billing/${key}`);
    },
    [navigate]
  );

  const defaultTab = canShowInvoices ? 'invoices' : 'disputes';
  const tab = params.tab || defaultTab;

  if (!canShowInvoices) {
    return <StandardNoAccessErrorMessage />;
  }

  return (
    <>
      <AppContent>
        <BillingPageStats />
        <div className="tabs">
          <Tabs
            activeKey={tab}
            defaultActiveKey={defaultTab}
            onTabClick={handleTabChange}
          >
            {canShowInvoices && (
              <Tabs.Pane tab="Invoices" key="invoices">
                <BillingInvoiceList />
              </Tabs.Pane>
            )}
            {canShowDisputes && (
              <Tabs.Pane tab="Supplier Disputes" key="disputes">
                <BillingDisputeList selectable={true} />
              </Tabs.Pane>
            )}
          </Tabs>
        </div>
      </AppContent>
      <style jsx>{`
        .tabs {
          margin-top: 24px;
        }
        .table-wrapper {
          padding-top: 3.5rem;
        }
        .center {
          display: flex;
          justify-content: center;
          width: 100%;
        }
        .heading-wrapper {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 2rem;
          margin-top: 1rem;
        }
      `}</style>
    </>
  );
};
